'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

EwSiteApp.factory('notify', ["$mdToast", function($mdToast){
	const successMessageDelay = 10000;
	const toastPosition = 'top left';
	const toastAction = 'close';
	const toastActionKey = 'q';
	return function(message){
		let msg = new String();
		if(angular.isArray(message)){
			msg = message.join(";\n");
		}
		else{
			msg = message;
		}
		let oo;
		if(arguments[1]){
			oo = $mdToast
				.simple()
				.textContent(msg)
				.position(toastPosition)
				.hideDelay(0)
				.action(toastAction)
				.actionKey(toastActionKey)
				.theme('error-toast')
				.toastClass('ew-notification')
		}
		else{
			oo = $mdToast
				.simple()
				.textContent(msg)
				.position(toastPosition)
				.hideDelay(successMessageDelay)
				.action(toastAction)
				.actionKey(toastActionKey)
				.theme('success-toast')
				.toastClass('ew-notification');
		}
		oo._options.template = '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}"><div class="md-toast-content" aria-live="polite" aria-relevant="all"><span class="md-toast-text">{{ toast.content }}</span><span class="md-visually-hidden">{{ toast.dismissHint }}</span><span class="md-visually-hidden" ng-if="toast.action && toast.actionKey">{{ toast.actionHint }}</span><md-button class="md-action md-icon-button" ng-click="toast.resolve()" ng-class="highlightClasses" aria-label="{{ toast.dismissHint }}"><md-icon ng-bind="toast.action"></md-icon></md-button></div></md-toast>';
		let prom = $mdToast.show(oo);
		if(true === arguments[2]){
			prom.then(function(){
				window.location.reload(true);
			}, function(){});
		}
	};
}]);